import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FilterTag from "../FilterTag";
import { Query } from "react-apollo";
import gql from "graphql-tag";

const categoryQuery = gql`
  query Category($id: ID!) {
    node(id: $id) {
      ... on Category {
        sourceTranslation {
          title
        }
      }
    }
  }
`;

export default class CategoryFilter extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };

  render() {
    const { onClick, type, value } = this.props;

    return (
      <Query
        query={categoryQuery}
        variables={{
          id: value,
        }}
      >
        {({ loading, error, data }) => (
          <FilterTag
            type={type}
            loading={loading}
            onClick={onClick}
            value={
              (data && data.node && data.node.sourceTranslation.title) || value
            }
          />
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/CategoryFilter/index.js